import { DefaultServiceMessages, Route } from "@repo/common"
import {
  queryOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query"
import { request } from "../api"

async function fetchDefaultMessages(): Promise<DefaultServiceMessages> {
  return await request<DefaultServiceMessages>({
    url: Route.SERVICE_SETTINGS_CONTROLLER__FIND_DEFAULT_MESSAGES,
    method: "GET",
  })
}

async function updateDefaultMessages(
  data: DefaultServiceMessages,
): Promise<DefaultServiceMessages> {
  return await request<DefaultServiceMessages>({
    url: Route.SERVICE_SETTINGS_CONTROLLER__UPDATE_DEFAULT_MESSAGES,
    method: "PUT",
    data,
  })
}

export const useUpdateDefaultMessages = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateDefaultMessages,
    onSuccess: (updated) =>
      queryClient.setQueryData(
        defaultMessagesQueries.detail().queryKey,
        updated,
      ),
  })
}

const defaultMessagesQueries = {
  all: () => ["default-messages"],
  detail: () =>
    queryOptions({
      queryKey: [...defaultMessagesQueries.all(), "detail"],
      queryFn: fetchDefaultMessages,
    }),
}

export default defaultMessagesQueries
